import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };

import { computed } from 'vue';
    import { Typo, TypoVariant, Icon, IconName, IconSize } from '@travelata-libs/ui-kit';

    interface EmiratesFilterProps {
        products?: { block?: boolean }[],
        modelValue: boolean;
        isHidden?: boolean;
        shouldVisible?: boolean
        classes?: string[];
        showCloseIcon?: boolean;
    }

    interface EmiratesFilterEmits {
        (event: 'update:modelValue', value: boolean): void;
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EmiratesFilter',
  props: {
    products: null,
    modelValue: { type: Boolean },
    isHidden: { type: Boolean },
    shouldVisible: { type: Boolean },
    classes: null,
    showCloseIcon: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (event: 'update:modelValue', value: boolean): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        products?: { block?: boolean }[],
        modelValue: boolean;
        isHidden?: boolean;
        shouldVisible?: boolean
        classes?: string[];
        showCloseIcon?: boolean;
    }

    

    
    const isVisible = computed(() =>  {
        if (props.shouldVisible) return true;
        if (props.isHidden) return false;
        if (props.products === undefined) return true;
        const isEveryToursBlock = props.products.every((p) => p.block);
        if (isEveryToursBlock) return false;

        return !!props.products.find((p) => p.block);
    });
    const typoText = computed(() => {
        if(props.showCloseIcon) {
            return props.modelValue ? '' : 'Показать туры на';
        } else {
            return props.modelValue ? 'Показать все туры' : 'Показать туры на';
        }
    });
    const typoVariant = computed(() => props.modelValue ? TypoVariant.BodyMMedium : TypoVariant.BodyMRegular);


return { __sfc: true,emit, props, isVisible, typoText, typoVariant, Typo, Icon, IconName, IconSize }
}

})